import React, { Component } from 'react'
import { Button,Modal, ModalHeader, ModalBody, ModalFooter,Form,FormGroup,Label,Table,FormText } from 'reactstrap';
import DropDown from 'shared/components/DropDown/index';
import Input from 'shared/components/Input/index';
import ActionButton from 'shared/components/ActionButton/index';
import TextArea from 'shared/components/Input/text_area';
import * as FontAwesome from 'react-icons/lib/fa';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import default_image from '../../../web/public/images/default.png';


export default class ContractPeriodicalModel extends Component {
  constructor() {
    super()
    this.cellActionButton = this.cellActionButton.bind(this);
    this.cellType=this.cellType.bind(this);
    this.cellTyperequired=this.cellTyperequired.bind(this);
   }

  cellActionButton(cell, row, enumObject, rowIndex) {
    let theButton;
      theButton = <div><ActionButton disabled={row.count>0?true:false} color={"danger"} value={row.field_id} size={"sm"} button_name={<FontAwesome.FaTrash/>} button_click={() => this.props.delete_report_click(row.field_id)} className="sub-header-button-right"/></div>
      return theButton;
  }

  cellType(cell, row, enumObject, rowIndex){
    let label;
    this.props.reporting_type.map(x=>{
      if(x.id==row.data_type_id)
      {
        label=<span key={x.id}>{x.name}</span>
      }
    })
    return label;
  }

  cellTyperequired(cell, row, enumObject, rowIndex){
    let label;
    if(row.is_mandatory==0){
      label=<span>Not Required</span>
    }
    else
    {
      label=<span>Required</span>
    }
    
    return label;
  }

  render() {
    return (
        <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className="modal-lg">
        <ModalHeader toggle={this.props.toggle}>Edit Contract Periodical</ModalHeader>
        
        <ModalBody>
        {this.props.periodical_data.map(x=>
            <div key={x.id}>
              <div className="row">
                <div className="col-md-12">
                  <FormGroup>
                    <Label>Name</Label><br/>
                     {x.name}
                  </FormGroup>
                </div>
              </div>

              <div className="row">

                <div className="col-md-12">
                  <FormGroup>
                    <Label>Description</Label><br/>
                  {x.description}
                  </FormGroup>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <FormGroup>
                    <Label>Default Frequency</Label><br/>
                    {this.props.frequency_data.map(f=>{
                      return(
                     <span key={f.id}> {f.id===x.occurrence_id?f.name:''}</span>
                      )
                    })}
                  </FormGroup>
                </div>
                <div className="col-md-6">
                  <FormGroup>
                    <Label>Occurrences count in frequency</Label><br/>
                    {x.frequency_count}
                  </FormGroup>
                </div>
              </div>

                <div className="row">
                  <div className="col-md-12">
                  <FormGroup>
                    <Label>Notes for staff work</Label>
                      {/* <Input type={"text"} id={"notes-"+ x.id} name="notes" value={x.notes} placeholder={""} onChange={this.props.onChange} maxLength={25}/> */}
                      <TextArea id={"notes-"+ x.id} name="notes" value={x.notes} placeholder={""} onChange={this.props.onChange} maxLength={200} rows={3} />
                  </FormGroup>
                  </div>
                </div>

              <FormGroup>
                <div className="form-check"><label className="form-check-label "><input type="checkbox" className="form-check-input" id={"is_separately_charge-" + x.id} value={x.is_separately_charge} checked={x.is_separately_charge} onChange={this.props.oncheck} /> Is separately charged</label></div>
              </FormGroup>

              {this.props.charged_show==1 ?
                <div className="row saparate-charge-div">
                  <div className="col-md-6">
                    <FormGroup>
                      <Label>Charge type</Label>
                      <DropDown name={"charge_type_id"} id={"charge_type_id-" + x.id} onChange={this.props.onChange} data={this.props.charge_data} value={x.charge_type_id} first_element={"--Select charge type--"} />
                      <span className="error-text">{this.props.validator.message('charge_type_id', x.charge_type_id, 'required|gt:0', false, { default: 'This field is required.' })}</span>
                    </FormGroup>
                  </div>
                  <div className="col-md-6">
                    <FormGroup>
                      <Label>Charge amount</Label>
                      <Input type={"number"} min={0} name={"charge_amount"} id={"charge_amount-" + x.id} onChange={this.props.onChange} maxLength={6} value={x.charge_amount}  />
                      <span className="error-text">{this.props.validator.message('charge_amount', x.charge_amount, 'required|max:6|gt:0', false, { default: 'This field is required.',max:'Maximum 6 character allowed.',gt:'Charge must be greater than zero.' })}</span>
                    </FormGroup>
                  </div>
                </div>
                : null}

                <FormGroup>

                <Label>Reporting fields</Label>
                {this.props.reporting_field.map(r =>
                  <div className="row" key={r.field_id}>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label>Label</Label>
                        <Input type={"text"} id={"label-" + r.field_id} name={"label"} maxLength={20}  value={r.label} onChange={this.props.onrChange} />
                        {/* <span className="error-text">{this.props.validator.message('label', r.label, 'required',false,{default: 'This field is required.'})}</span>  */}
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <Label>Type</Label>
                        <DropDown id={"data_type_id-" + r.field_id} name={"data_type_id"} value={r.data_type_id} onChange={this.props.onrChange} data={this.props.reporting_type} first_element={"--Select type--"} />
                        {/* <span className="error-text">{this.props.validator.message('data_type_id', x.data_type_id, 'required',false,{default: 'This field is required.'})}</span> */}
                      </FormGroup>
                    </div>
                    <div className="col-md-3" style={{ paddingTop: "30px" }}>
                      <FormGroup>
                        <label className="form-check-label "><input type="checkbox" className="form-check-input" name={"is_mandatory"} id={"is_mandatory-" + r.field_id} value={r.is_mandatory} checked={r.is_mandatory} onChange={this.props.onMandatoryCheck} />Mandatory </label>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <br />
                      <ActionButton color={"primary"} size={"sm"} button_name={"Save"} button_click={this.props.saveClick} className="sub-header-button-right " />
                      <ActionButton color={"danger"} size={"sm"} button_name={"Cancel"} button_click={this.props.rCancel} className="sub-header-button-right"/> 
                    </div>
                  </div>
                )}
                </FormGroup>

            <FormGroup>
             <Label>Reporting fields</Label>
              <div className="row">
              <div className="col-md-12">
                 <BootstrapTable ref='table' data={this.props.reporting_array } >
                  <TableHeaderColumn dataField='label' isKey={ true } >Label Text</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={this.cellType} >Data Type</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={this.cellTyperequired} >Is Required</TableHeaderColumn>
                  <TableHeaderColumn dataField='' dataFormat={this.cellActionButton}>Action</TableHeaderColumn>
                </BootstrapTable>
              </div>
              </div>
            </FormGroup>
          </div>
        )}
        </ModalBody>
       
        <ModalFooter>
          <ActionButton color={"primary"} size={"md"} button_name={"Save & Close"} button_click={this.props.onSubmitClick}/>{' '}
          <ActionButton color={"danger"} size={"md"} button_name={"Cancel"} button_click={this.props.toggle}/>
        </ModalFooter>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Models/contract_periodical_model.js